import { hasCapability, type User } from "../base";

export const colorSelection = {
  read: (user: User) => hasCapability(user, "colorSelection.read"),
  update: (user: User) => hasCapability(user, "colorSelection.update"),
  reset: (user: User) => hasCapability(user, "colorSelection.reset"),
};
